module.exports = __webpack_public_path__ + "img/WKYMVm.6c655283.png";